import { render, staticRenderFns } from "./roleMenber.vue?vue&type=template&id=a9effa32&scoped=true"
import script from "./roleMenber.vue?vue&type=script&lang=js"
export * from "./roleMenber.vue?vue&type=script&lang=js"
import style0 from "./roleMenber.vue?vue&type=style&index=0&id=a9effa32&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9effa32",
  null
  
)

export default component.exports